export default "__VITE_ASSET__owpR$Tqd__"